import { ITestCase } from "../../../entities/src/testCase";
import { Modelable } from "../../../entities/src/modelable";

export class TestCase implements Modelable<ITestCase> {
    constructor(public data: ITestCase) {}
}
